  
  import React from 'react'
  
  const Offerscard = () => {
      return (
        <div className="box">
            <div className="container">
              <div className="row">   
     
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="box-part text-center">
                            <img src="https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_40,h_40/le7uofmwurscrjndqpjf" alt="sc" width="50" height="50"/>

                            <div className="title">
                                <h4>SAC_15</h4>
                            </div>
                            
                            <div className="offers-card-text">
                                <span>Get 15% discount using Standard Chartered Bank Cards.</span>
                                <p>Use code SAC_15 & get 15% discount up to Rs.100 on orders above Rs.500</p>
                            </div>
                            
                            <a href="/more">Learn More</a>
                            
                        </div>
                    </div>	
              </div>
             </div>
        </div>
          
      )
  }
  
  export default Offerscard
  
  
  